var _indexOf = require('./_indexOf');


module.exports = function _contains(a, list) {
  return _indexOf(list, a, 0) >= 0;
};



//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_contains.js
// module id = 43
// module chunks = 34471704633725 35783957827783 216468464745311